<template>
	<v-col cols="3" align-center class="quality-column">
		<v-icon large class="quality-icon mb-4" color="primary" align-self="center">
			{{iconName}}
		</v-icon>
		<p class="text-h5">
			{{headText}}
		</p>
		<v-divider class="primary mb-3"></v-divider>
		<p>
			{{description}}
		</p>
	</v-col>
</template>

<script>

export default {
	name: "QualityColum",
	
	props: {
		iconName: String,
		headText: String,
		description: String,
	}
}
	
</script>

<style scoped>
	.quality-column {
		text-align: center;
	}
	
	.quality-icon {
		cursor: pointer;
	}
	
	.quality-icon:hover {
		transform: rotateY(45deg);
	}
</style>